import type { QueryClient } from "@tanstack/react-query";

// Query keys, so both are persisted with the cache and a reload resumes from them.
export const CURSOR = ["sync", "cursor"] as const;
export const FIRST_READ = ["sync", "first-read"] as const;

// Half the one-minute freshness promise, so a write made just after a poll still arrives inside it.
export const POLL_EVERY = 30_000;

/**
 * A list read whole before the first delta read hands over the server's cursor; the earliest is
 * kept, so no list misses a change made after it was read.
 */
export function noteRead(queryClient: QueryClient, cursor: string): void {
  const held = queryClient.getQueryData<string>(FIRST_READ);
  if (held === undefined || Date.parse(cursor) < Date.parse(held)) {
    queryClient.setQueryData<string>(FIRST_READ, cursor);
  }
}
